import { render, staticRenderFns } from "./Lgx02655471597807026044961.vue?vue&type=template&id=3f107cdb&scoped=true&"
import script from "./Lgx02655471597807026044961.vue?vue&type=script&lang=js&"
export * from "./Lgx02655471597807026044961.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02655471597807026044961.vue?vue&type=style&index=0&id=3f107cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f107cdb",
  null
  
)

export default component.exports